<template>
    <div class="property-feature" :class="{show: show}">
        <template v-for="(group, i) in getFeatures">
            <table v-if="group && group.length" v-bind:key="group">
                <tbody>
                    <template v-for="item in group" v-bind:key="item.name">
                        <tr>
                            <td class="text-bold">{{ item.name }}</td>
                            <td >
                                <template v-if="['Virtual Tour'].includes(item.name)">
                                    <a v-nhs:tour class="link" v-if=" dpp.virtualLink" @click="pop3d( dpp.virtualLink)" rel="nofollow" role="button">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <span v-else>N/A</span>
                                </template>
                                <template v-else-if="['3-D Tour','3D Tour'].includes(item.name)">
                                    <a class="link" v-if="dpp.threeDTourLink" @click="pop3d(dpp.threeDTourLink)" rel="nofollow" role="button">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <span v-else>N/A</span>
                                </template>
                                <template v-else-if="(item.name && (~item.name.indexOf('Website') || ~item.name.indexOf('Link')) || item.name == 'Builder') && isValidURL(item.value)">
                                    <a v-nhs:clickthrough v-if="['Builder','Subdivision Website'].indexOf(item.name) !== -1 " class="link" :href="item.value" rel="nofollow" target="_blank">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <a v-nhs:click v-else-if="['Sales Office Website','Home Details Website'].indexOf(item.name) !== -1" class="link" :href="item.value" rel="nofollow" target="_blank">{{molang('dpp.propertyFeature.extLink')}}</a>
                                    <a v-else class="link" :href="item.value" rel="nofollow" target="_blank">{{molang('dpp.propertyFeature.extLink')}}</a>
                                </template>
                                <span v-else-if="group.name === 'Rooms Information'"
                                    v-html="item.value.replace('dimension', glb.unit === 'metric' ? item.sizeM : item.sizeI)" />
                                <span v-else>{{item.value}}</span>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
        <button type="button" class="link btn-show" @click="toggle">{{ show ? 'Show less' : 'Show all' }} <i :class="show ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
    </div>
</template>

<script src="./property-feature.js"></script>

<style lang="scss">
    @use './property-feature.scss' as *;
</style>
